
import { Component, Vue } from 'vue-property-decorator'
import { emojiList, emojiListEnglist } from '@/utils/const'
import Bus from '@/utils/bus'

@Component
export default class EmojiPicker extends Vue {
  emojiList = this.$i18n.locale === 'en_US' ? emojiListEnglist : emojiList

  getUrl(index: number) {
    const url = require(`@/assets/emoji/smiley_${index}.png`)
    return url
  }

  handleClick(obj: any) {
    const emojiText = `[${obj}]`
    Bus.$emit('insertEmoji', emojiText)
  }
}
